<template>
  <div class="mapLocationInput">
    <map-container
      :location="location"
      @change="emitChange"
    >
    </map-container>
  </div>
</template>

<script>
import MapContainer from '@/components/map/MapContainer';

export default {
  model: {
    prop: 'location',
    event: 'change',
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  components: {
    MapContainer,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    emitChange({ lat, lng }) {
      this.$emit('change', { lat, lng });
    },
  },
};
</script>
<style lang="scss">
.mapLocationInput {
  width: 600px;
}
</style>
